// Datos visuales de las plantillas. La estructura real (triggers/steps) la
// arma el backend en Bots::TemplateApplier. Acá solo mostramos las cards.

export const TEMPLATE_CATEGORIES = [
  { key: 'all',              label: 'Todas las plantillas' },
  { key: 'lead_generation',  label: 'Generar leads' },
  { key: 'commercial_info',  label: 'Información comercial' },
  { key: 'lead_nurture',     label: 'Cultivar leads' },
  { key: 'work_reduction',   label: 'Reducir trabajo' },
];

export const CHANNELS = [
  { key: 'whatsapp',   label: 'WhatsApp Business', color: '#25D366' },
  { key: 'telegram',   label: 'Telegram',          color: '#0088cc' },
  { key: 'instagram',  label: 'Instagram',         color: '#E1306C' },
  { key: 'tiktok',     label: 'TikTok',            color: '#000000' },
  { key: 'messenger',  label: 'Messenger',         color: '#0084FF' },
  { key: 'email',      label: 'Correo',            color: '#F59E0B' },
  { key: 'web_widget', label: 'Chat en vivo',      color: '#7C3AED' },
];

export const TEMPLATES = [
  {
    key: 'welcome',
    name: 'Bot de bienvenida',
    category: 'lead_generation',
    bg: 'bg-emerald-100',
    bubble: '¿En qué ayudo? 👋',
    channels: ['whatsapp', 'instagram', 'messenger', 'web_widget'],
  },
  {
    key: 'confirm_appointment',
    name: 'Seguimiento para confirmar citas',
    category: 'commercial_info',
    bg: 'bg-rose-100',
    bubble: '¿Aún vienes mañana? ⏰',
    channels: ['whatsapp', 'instagram'],
  },
  {
    key: 'receive_appointment',
    name: 'Recibir reservas de citas',
    category: 'commercial_info',
    bg: 'bg-yellow-100',
    bubble: '¿Ya has venido? 👍',
    channels: ['whatsapp'],
  },
  {
    key: 'capture_call_lead',
    name: 'Captura leads que desean una llamada',
    category: 'lead_generation',
    bg: 'bg-emerald-100',
    bubble: '+1-234-567-89',
    channels: ['whatsapp', 'web_widget'],
  },
  {
    key: 'callback_request',
    name: 'Devolución de llamada',
    category: 'lead_generation',
    bg: 'bg-amber-100',
    bubble: '+54 9 (11) 6932-2895',
    channels: ['whatsapp'],
  },
  {
    key: 'discount_codes',
    name: 'Códigos por menciones en historias',
    category: 'lead_nurture',
    bg: 'bg-pink-100',
    bubble: 'DESC20',
    channels: ['instagram'],
  },
  {
    key: 'tiktok_keywords',
    name: 'Responde a palabras clave en TikTok',
    category: 'lead_nurture',
    bg: 'bg-orange-100',
    bubble: '¡Ya estás participando!',
    channels: ['tiktok'],
  },
  {
    key: 'tiktok_comments',
    name: 'Reacciona a comentarios de TikTok',
    category: 'lead_nurture',
    bg: 'bg-pink-100',
    bubble: '¡Gracias, Andrea! ❤',
    channels: ['tiktok'],
  },
  {
    key: 'share_giveaway',
    name: 'Comparte premios exclusivos',
    category: 'lead_generation',
    bg: 'bg-orange-100',
    bubble: 'Aquí tienes tu guía gratuita 🎁',
    channels: ['whatsapp', 'instagram'],
  },
  {
    key: 'catalog_request',
    name: 'Catálogos por palabras clave',
    category: 'lead_generation',
    bg: 'bg-blue-100',
    bubble: '¡Descarga el catálogo!',
    channels: ['whatsapp'],
  },
  {
    key: 'round_robin',
    name: 'Distribuye conversaciones (Round Robin)',
    category: 'work_reduction',
    bg: 'bg-purple-100',
    bubble: 'Round Robin entre agentes',
    channels: ['whatsapp', 'instagram', 'web_widget', 'email'],
  },
  {
    key: 'nps_survey',
    name: 'Encuesta NPS al cerrar',
    category: 'work_reduction',
    bg: 'bg-cyan-100',
    bubble: 'Califícanos del 1 al 10',
    channels: ['whatsapp', 'email'],
  },
];
